var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 19.7406L19.996 1.74072C21.5873 1.74072 23.1134 2.37286 24.2386 3.49807C25.3638 4.62328 25.9959 6.1494 25.9959 7.74068V15.7406H37.3159C37.8957 15.7341 38.47 15.8536 38.999 16.0911C39.528 16.3285 39.9991 16.6781 40.3796 17.1157C40.7601 17.5532 41.0409 18.0683 41.2025 18.6251C41.3642 19.182 41.4029 19.7673 41.3158 20.3406L38.5559 38.3405C38.4112 39.2943 37.9267 40.1637 37.1917 40.7885C36.4566 41.4133 35.5205 41.7514 34.5559 41.7405H11.996M11.996 19.7406V41.7405M11.996 19.7406H5.99607C4.93521 19.7406 3.9178 20.162 3.16766 20.9122C2.41752 21.6623 1.99609 22.6797 1.99609 23.7406V37.7405C1.99609 38.8014 2.41752 39.8188 3.16766 40.5689C3.9178 41.319 4.93521 41.7405 5.99607 41.7405H11.996",
    stroke: "#F74F38",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList3);
export default __webpack_public_path__ + "static/media/list_3.f40a80e0f824df9f1415d648ca3bba6a.svg";
export { ForwardRef as ReactComponent };